// switch-carousel.js
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.swc').forEach(initCarousel);
});

function initCarousel(root) {
  const track = root.querySelector('.swc__track');
  const cards = root.querySelectorAll('.swc__card');
  const dots = root.querySelectorAll('.swc__dot');
  const prevBtn = root.querySelector('[data-direction="prev"]');
  const nextBtn = root.querySelector('[data-direction="next"]');
  if (!track || cards.length === 0) return;

  function scrollToIndex(index) {
    const card = cards[index];
    if (!card) return;
    track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
  }

  function updateActiveDot() {
    const trackRect = track.getBoundingClientRect();
    let closestIndex = 0;
    let closestDist = Infinity;
    cards.forEach((card, i) => {
      const cardRect = card.getBoundingClientRect();
      const dist = Math.abs(cardRect.left - trackRect.left);
      if (dist < closestDist) { closestDist = dist; closestIndex = i; }
    });
    dots.forEach((d, i) => d.classList.toggle('swc__dot--active', i === closestIndex));
    return closestIndex;
  }

  prevBtn?.addEventListener('click', () => {
    const current = updateActiveDot();
    scrollToIndex(Math.max(0, current - 1));
  });
  nextBtn?.addEventListener('click', () => {
    const current = updateActiveDot();
    scrollToIndex(Math.min(cards.length - 1, current + 1));
  });

  let scrollTimeout;
  track.addEventListener('scroll', () => {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(updateActiveDot, 100);
  });
}
